// frontend/src/features/drivers/DriverEditModal.js
// This modal component lets users edit a driver’s details (name/VRN/phone/email), sends the update to the backend via Axios, and then notifies the parent through onUpdate/onClose.
import React, { useState } from 'react';
import axios from 'axios';

export default function DriverEditModal({ driver, onClose, onUpdate }) {
  const [name, setName] = useState(driver.name);
  const [vehicleRegistrationNumber, setVehicleRegistrationNumber] = useState(driver.vehicle_registration_number);
  const [phone, setPhone] = useState(driver.phone);
  const [email, setEmail] = useState(driver.email);
  const [error, setError] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `/agencies/drivers/${driver.id}`,  // axios.defaults.baseURL + this path
        {
          name,
          vehicle_registration_number: vehicleRegistrationNumber,
          phone,
          email,
        }
      );
      onUpdate(response.data);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Error updating driver');
    }
  };
  

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-md p-6 w-full max-w-md"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Edit Driver</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl font-bold"
          >
            &times;
          </button>
        </div>

        {error && (
          <div className="mb-4 text-sm text-red-700 bg-red-100 p-3 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Name Field */}
          <div>
            <label htmlFor="edit-name" className="block text-gray-700 mb-1">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              id="edit-name"
              type="text"
              required
              value={name}
              onChange={e => setName(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {/* Vehicle Registration Field */}
          <div>
            <label htmlFor="edit-vrn" className="block text-gray-700 mb-1">
              Vehicle Registration <span className="text-red-500">*</span>
            </label>
            <input
              id="edit-vrn"
              type="text"
              required
              value={vehicleRegistrationNumber}
              onChange={e => setVehicleRegistrationNumber(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {/* Phone Field */}
          <div>
            <label htmlFor="edit-phone" className="block text-gray-700 mb-1">
              Phone
            </label>
            <input
              id="edit-phone"
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {/* Email Field */}
          <div>
            <label htmlFor="edit-email" className="block text-gray-700 mb-1">
              Email
            </label>
            <input
              id="edit-email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90 transition"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
